import * as React from 'react';
import { ArchetypeSpecificStepRunSummaryPanelProps } from '.';

export const BetaTestingStepRunSummaryPanel: React.FC<ArchetypeSpecificStepRunSummaryPanelProps> = ({ stepRun }) => {
    return <div>Beta Testing Step Run Summary Panel - {stepRun.displayName || stepRun.stepId}</div>;
};
